import { FC, useState } from 'react';

import styles from './business-hub-faq.module.scss';
import FAQItem from './faq-item/faq-item';

export interface BusinessHubFAQProps {
    title?: string;
    description?: string;
    items?: {
        question: string;
        answer: string;
    }[];
}

const BusinessHubFAQ: FC<BusinessHubFAQProps> = (props) => {
    const { title, description, items } = props;
    const [currentOpenQuestion, setCurrentOpenQuestion] = useState<string | null>(null);
    const [showAll, setShowAll] = useState(false);

    const handleViewMore = () => {
        setShowAll(true);
    };

    const handleQuestionClick = (question: string) => {
        if (question === currentOpenQuestion) {
            setCurrentOpenQuestion(null);
        } else {
            setCurrentOpenQuestion(question);
        }
    };

    const displayedItems = showAll ? items : items?.slice(0, 3);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></div>
                <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>
                <div className={styles.wrapperFAQ}>
                    {displayedItems?.map((item, index) => {
                        return (
                            <FAQItem
                                key={index}
                                question={item.question}
                                answer={item.answer}
                                isOpen={item.question === currentOpenQuestion}
                                onQuestionClick={handleQuestionClick}
                                zIndex={displayedItems.length - index}
                            />
                        );
                    })}

                    {!showAll && items && items.length > 3 && (
                        <div className={styles.btnViewMore} onClick={handleViewMore}>
                            <span className={styles.text}>View more</span>
                            <div className={styles.iconArrow}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                    <path d="M1 3.5L6.5 9.5L12 3.5" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BusinessHubFAQ;
